import { useState, useEffect } from 'react';

export function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToProducts = () => {
    const productsSection = document.getElementById('featured-products');
    productsSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 flex items-center justify-center">
              <i className="ri-store-2-line text-3xl" style={{ color: scrolled ? '#2A2A2A' : '#2A2A2A' }}></i>
            </div>
            <span className={`text-xl font-semibold transition-colors ${scrolled ? 'text-gray-900' : 'text-gray-900'}`} style={{ fontFamily: 'Playfair Display, serif' }}>Local Shop</span>
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a href="#featured-products" className={`text-sm font-medium transition-colors hover:text-[#8B9B7E] ${scrolled ? 'text-gray-700' : 'text-gray-700'}`}>Products</a>
            <a href="#about" className={`text-sm font-medium transition-colors hover:text-[#8B9B7E] ${scrolled ? 'text-gray-700' : 'text-gray-700'}`}>About</a>
            <a href="#gallery" className={`text-sm font-medium transition-colors hover:text-[#8B9B7E] ${scrolled ? 'text-gray-700' : 'text-gray-700'}`}>Gallery</a>
            <a href="#location" className={`text-sm font-medium transition-colors hover:text-[#8B9B7E] ${scrolled ? 'text-gray-700' : 'text-gray-700'}`}>Location</a>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="w-full max-w-7xl mx-auto px-8 py-20 grid md:grid-cols-2 gap-12 items-center">
        {/* Left Content */}
        <div className="space-y-6 md:pr-12">
          <div className="flex items-center gap-2">
            <span className="text-xs uppercase tracking-[0.15em] font-medium" style={{ color: '#C67B5C' }}>LOCAL</span>
            <span className="text-xs" style={{ color: '#C67B5C' }}>•</span>
            <span className="text-xs uppercase tracking-[0.15em] font-medium" style={{ color: '#C67B5C' }}>TRUSTED</span>
            <span className="text-xs" style={{ color: '#C67B5C' }}>•</span>
            <span className="text-xs uppercase tracking-[0.15em] font-medium" style={{ color: '#C67B5C' }}>COMMUNITY</span>
          </div>
          
          <h1 className="text-6xl md:text-7xl font-bold leading-tight text-gray-900" style={{ fontFamily: 'Playfair Display, serif', lineHeight: '1.1' }}>
            A Local Shop You'll Love
          </h1>
          
          <p className="text-lg text-gray-600 max-w-md leading-relaxed">
            Quality products and friendly service right here in your community.
          </p>
          
          <div className="flex flex-wrap gap-4 pt-4">
            <a 
              href="#location" 
              className="px-8 py-4 rounded-full text-white font-medium transition-all duration-300 hover:-translate-y-1 hover:shadow-lg whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#8B9B7E' }}
            >
              Visit Our Store
            </a>
            <button 
              onClick={scrollToProducts}
              className="px-8 py-4 rounded-full font-medium transition-all duration-300 hover:-translate-y-1 border-2 whitespace-nowrap cursor-pointer"
              style={{ borderColor: '#8B9B7E', color: '#8B9B7E' }}
            >
              See Featured Products
            </button>
          </div>
        </div>

        {/* Right Image */}
        <div className="relative">
          <div className="rounded-3xl overflow-hidden shadow-2xl" style={{ boxShadow: '0 20px 60px rgba(0,0,0,0.08)' }}>
            <img 
              src="https://readdy.ai/api/search-image?query=warm%20inviting%20modern%20retail%20shop%20interior%20with%20natural%20lighting%20wooden%20shelves%20displaying%20curated%20products%20soft%20afternoon%20sunlight%20streaming%20through%20large%20windows%20cozy%20boutique%20atmosphere%20clean%20minimalist%20design%20with%20plants%20and%20warm%20textures%20welcoming%20shopping%20environment%20high%20quality%20professional%20photography&width=800&height=1000&seq=hero-shop-interior&orientation=portrait"
              alt="Shop Interior"
              className="w-full h-full object-cover"
              style={{ aspectRatio: '4/5' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}